import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFocusPanelTodos } from './useFocusPanelTodos';
import FocusPanelActivity from './FocusPanelActivity';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../style/scss/dashboard.scss';

const FocusPanel: React.FC = () => {
    const { t } = useTranslation();
    const { loading, visibleRows, navigateToItem } = useFocusPanelTodos();

    return (
        <div className='focus-panel'>
            <div className='focus-panel-todos dashboard-card'>
                <h5>{t('dashboard.general.todos_today_title')}</h5>
                <div className='focus-panel-list'>
                    {loading ? (
                        // Show a loader while the data is still being fetched
                        <div className='metric-chart-loading'>
                            <div className='loader' />
                        </div>
                    ) : visibleRows.length > 0 ? (
                        visibleRows.map(({ item, count }) => (
                            <div className='focus-panel-row' key={item.key} onClick={() => navigateToItem(item)}>
                                <span className='label'>{count} {t(item.label)}</span>
                                <span className='icon'><FontAwesomeIcon icon={faAngleRight} /></span>
                            </div>
                        ))
                    ) : (
                        // Only show the finished todos row once loading is done and nothing is left to do
                        <div className='finished-todo-row'>
                            <span className='label'>{t('dashboard.general.todos_all_is_done_label')}</span>
                        </div>
                    )}
                </div>
            </div>
            <FocusPanelActivity />
        </div>
    );
};

export default FocusPanel;
